const contactsWidget = () => {

    const widget            = $('.js-widget');
    const button            = $('.js-widget-trigger');
    const activeClass       = '_contacts-widget-shown';
    const buttonActiveClass = '_active';

    button.on('click', function(){
        if ( !APP.websiteWrapper.hasClass(activeClass) ) {
            setWidth();
            APP.websiteWrapper.addClass(activeClass);
            $(this).addClass(buttonActiveClass);
        }
        else {
            unsetWidth();
            APP.websiteWrapper.removeClass(activeClass);
            $(this).removeClass(buttonActiveClass);
        }
    });

    $(document).on("mouseup touchend", function(e){
        if (!widget.is(e.target) && widget.has(e.target).length === 0) {
            unsetWidth();
            APP.websiteWrapper.removeClass(activeClass);
            button.removeClass(buttonActiveClass);
        }
    });

}